<template>
  <div class="va-row">
    <div class="flex md12 xs12">
      <vuestic-widget :headerText="'extensions.create_title' | translate">
        <form @submit.prevent="createExtension">
          <div class="va-row">
            <div class="flex md6 xs12">
              <div
                class="form-group required"
                :class="error.name ? 'has-error' : ''"
              >
                <div class="input-group">
                  <input type="text" id="name" required v-model="model.name" />
                  <label class="control-label" for="name">
                    {{ $t('extensions.form.name') }}
                  </label>
                  <i class="bar"></i>
                  <span class="small text-danger">{{ error.name }}</span>
                </div>
              </div>
            </div>
            <div class="flex md6 xs12 ">
              <div
                class="form-group required"
                :class="error.email ? 'has-error' : ''"
              >
                <div class="input-group">
                  <input
                    type="email"
                    id="email"
                    required
                    v-model="model.email"
                  />
                  <label class="control-label" for="email">
                    {{ $t('extensions.form.email') }}
                  </label>
                  <i class="bar"></i>
                  <span class="small text-danger">{{ error.email }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="va-row">
            <div class="flex md6 xs12">
              <div
                class="form-group required"
                :class="error.ext ? 'has-error' : ''"
              >
                <div class="input-group">
                  <input
                    type="number"
                    id="ext_number"
                    required
                    v-model="model.ext"
                  />
                  <label class="control-label" for="ext_number"
                    >Extension Number</label
                  >
                  <i class="bar"></i>
                  <span class="small text-danger">{{ error.ext }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="va-row mt-5">
            <div class="flex md6 xs12">
              <div class="form-group" :class="error.inbound ? 'has-error' : ''">
                <div class="input-group">
                  <label class="form-label">Inbound Calls</label>
                  <vuestic-switch v-model="model.inbound">
                    <span slot="trueTitle">Enable</span>
                    <span slot="falseTitle">Disable</span>
                  </vuestic-switch>
                  <span class="small text-danger">{{ error.inbound }}</span>
                </div>
              </div>
            </div>
            <div class="flex md6 xs12">
              <div
                class="form-group"
                :class="error.outbound ? 'has-error' : ''"
              >
                <div class="input-group">
                  <label class="form-label">Outbound Calls</label>
                  <vuestic-switch v-model="model.outbound">
                    <span slot="trueTitle">Enable</span>
                    <span slot="falseTitle">Disable</span>
                  </vuestic-switch>
                  <span class="small text-danger">{{ error.outbound }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="va-row">
            <div class="flex md6 xs12">
              <div
                class="form-group"
                :class="error.voicemail ? 'has-error' : ''"
              >
                <div class="input-group">
                  <label class="form-label">{{
                    'extensions.form.voicemail' | translate
                  }}</label>
                  <vuestic-switch v-model="model.voicemail">
                    <span slot="trueTitle">
                      {{ 'extensions.form.yes' | translate }}
                    </span>
                    <span slot="falseTitle">
                      {{ 'extensions.form.no' | translate }}
                    </span>
                  </vuestic-switch>
                  <span class="small text-danger">{{ error.voicemail }}</span>
                </div>
              </div>
            </div>
            <div class="flex md6 xs12">
              <br />
              <div
                class="form-group required"
                :class="error.pin ? 'has-error' : ''"
              >
                <div class="input-group">
                  <input type="number" id="pin" required v-model="model.pin" />
                  <label class="control-label" for="pin">Pin</label>
                  <i class="bar"></i>
                  <span class="small text-danger">{{ error.pin }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="va-row justify--center">
            <half-circle-spinner
              slot="loading"
              :animation-duration="1500"
              :size="50"
              color="#94c120"
              v-show="formLoading"
            />
            <button
              v-if="!formLoading"
              class="btn btn-primary btn-sm btn-with-icon-sm rounded"
            >
              <div class="btn-with-icon-content">
                <i class="ion-md-add ion"></i>
                {{ 'buttons.create' | translate }}
              </div>
            </button>
          </div>
        </form>
        <app-popup>
          <template slot="popup-content">
            <h4 class="text-primary">Do you want to send credentials email?</h4>
            <div class="px-4">
              <!-- <wysiwyg v-model="emailHTML" /> -->
              <div class="emailHTML" v-html="emailHTML"></div>
              <div class="va-row buttons-container w-100 justify--center">
                <half-circle-spinner
                  slot="loading"
                  :animation-duration="1500"
                  :size="50"
                  color="#94c120"
                  v-show="sendingEmail"
                  class="mt-2"
                />
                <div class="flex col" v-if="!sendingEmail">
                  <button
                    type="button"
                    class="btn btn-primary btn-block btn-micro"
                    @click="sendEmail"
                  >
                    Send
                  </button>
                </div>
                <div class="flex col" v-if="!sendingEmail">
                  <button
                    type="button"
                    class="btn btn-danger btn-block btn-micro"
                    @click="dismissPopup"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </template>
        </app-popup>
      </vuestic-widget>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import HalfCircleSpinner from 'epic-spinners/src/components/lib/HalfCircleSpinner'

export default {
  components: {
    HalfCircleSpinner
  },
  data() {
    return {
      formLoading: false,
      sendingEmail: false,
      model: {
        inbound: true,
        outbound: true,
        voicemail: true
      },
      error: {},
      emailError: null,
      emailHTML: '',
      createdExtensionID: 0
    }
  },
  methods: {
    ...mapActions(['sendCredentialsEmail', 'fetchLastExtensionNumber']),
    async createExtension() {
      this.formLoading = true
      this.error = {}
      const response = await this.$store.dispatch('createExtension', this.model)
      if (response.success) {
        this.$toasted.show(response.data.message, {
          icon: 'fa-check-circle',
          position: 'top-right',
          duration: 5000,
          fullWidth: false
        })
        this.model = {
          inbound: true,
          outbound: true,
          voicemail: true
        }
        this.emailHTML = response.data.mailContent
        this.createdExtensionID = response.data.id
        this.$store.dispatch('togglePopup', true)
      } else {
        this.error = response.errors
      }
      this.formLoading = false
    },
    async sendEmail() {
      this.sendingEmail = true
      const response = await this.sendCredentialsEmail({
        extension_id: this.createdExtensionID,
        message: this.emailHTML
      })
      if (response.success) {
        this.$toasted.show(response.data.message, {
          icon: 'fa-check-circle',
          position: 'top-right',
          duration: 5000,
          fullWidth: false
        })
        this.emailHTML = ''
        this.sendingEmail = false
        this.$store.dispatch('togglePopup', false)
        this.$router.push({ name: 'all-extensions' })
      } else {
        this.sendingEmail = false
        this.emailError = response.errors.message
      }
    },
    dismissPopup() {
      this.$store.dispatch('togglePopup', false)
      this.$router.push({ name: 'all-extensions' })
    }
  },
  computed: {
    ...mapGetters(['currentAccount'])
  },
  async created() {
    this.formLoading = true
    const response = await this.fetchLastExtensionNumber()
    if (response.success) {
      this.model.ext = response.data
    }
    this.formLoading = false
  }
}
</script>
<style lang="scss" scoped>
h4 {
  margin-top: 0;
}
.buttons-container {
  margin: 0 !important;
}
.emailHTML {
  max-height: 200px;
  overflow: auto;
  padding: 10px;
  border: 1px solid lighten($gray, 20%);
  border-radius: 0.5rem;
  margin-bottom: 10px;
}
</style>
<style>
.editr--content {
  max-height: 200px !important;
}
</style>
